exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* tfoot {\n    display: table-footer-group;\n    vertical-align: middle;\n    border-color: inherit;\n    background-color: red;\n} */", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/courseridden-user-list/courseridden-user-list.component.css
// module id = 399
// module chunks = 0